<template>

  <AbortStateTemplate
      :message="abortMessage"
      :teaserCards="teaserCardsData"
  />
</template>


<script>
import teaserCardsData from "@/data/teaserData";
import AbortStateTemplate from "@/components/abortStates/AbortStateTemplate.vue";

export default {
  name: 'StateAbortOwner',
  components: {
    AbortStateTemplate,
  },
  data() {
    return {
      abortMessage:
          "Aufgrund Ihrer Angaben zur Eigentümerschaft des Objektes können wir Ihnen leider kein Angebot erstellen. " +
          "Unser Angebot richtet sich an alleinige Hauseigentümer und Hauseigentümerinnen. Eigentümergemeinschaften sind aktuell ebenfalls ausgeschlossen.",
      teaserCardsData
    };
  },
}
</script>

<style scoped>

</style>
